import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2, H5 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIList from 'UIComponents/list/UIList';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIButton from 'UIComponents/button/UIButton';
import UISection from 'UIComponents/section/UISection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WebhookCreationSuccessStep = ({
  onSaveWebhook,
  webhookSaveCalled,
  webhookSaveLoading,
  webhookSaveError
}) => {
  React.useEffect(onSaveWebhook, [onSaveWebhook]);
  if (!webhookSaveCalled || webhookSaveLoading && !webhookSaveError) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered"
    });
  }
  if (webhookSaveError) {
    return /*#__PURE__*/_jsxs("div", {
      className: "text-center",
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.creationFinalization.error.title"
        })
      }), /*#__PURE__*/_jsx(UIIllustration, {
        name: "errors/general",
        width: "40%"
      }), /*#__PURE__*/_jsx(UISection, {
        use: "island",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.creationFinalization.error.description"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: onSaveWebhook,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.creationFinalization.error.tryAgain"
          })
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H2, {
      className: "text-center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.creationFinalization.success.title"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "text-center",
      children: /*#__PURE__*/_jsx(UIIllustration, {
        name: "success-green",
        width: "30%"
      })
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.creationFinalization.success.upNext.title"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      className: "m-bottom-3",
      message: "automation-ui-enrollment.webhookWizard.creationFinalization.success.upNext.description"
    }), /*#__PURE__*/_jsxs(UIList, {
      ordered: true,
      styled: true,
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.creationFinalization.success.upNext.steps.triggerSetup"
        })
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.creationFinalization.success.upNext.steps.findTrigger"
        })
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.creationFinalization.success.upNext.steps.placeInWorkflow"
        })
      })]
    })]
  });
};
export default WebhookCreationSuccessStep;